export const serviceInvitedI18nKeys = {
    Todo: 'REAL_ESTATE_AGENT.DASHBOARD.DETAIL.SETTING_THE_SCENE',
};
